export const DEMO_PLAYER_BASE_URL = "https://tools.blings.io/demo/";

type DemoScene = string | { lineup?: string | null };

export type DemoPlayerUrlOptions = {
  projectId: string;
  env: string;
  scenes?: DemoScene[];
  data?: object | null;
  playerVersion?: string;
  draftVersion?: string;
};

function getFlowItem(scene: DemoScene): string | null {
  if (typeof scene === "string") {
    return `scene:${scene}`;
  }

  if (scene.lineup) {
    return `lineup:${scene.lineup}`;
  }

  return null;
}

function isFlowItem(value: string | null): value is string {
  return Boolean(value);
}

export function getDemoPlayerUrl({
  projectId,
  env,
  scenes,
  data,
  playerVersion,
  draftVersion,
}: DemoPlayerUrlOptions): string {
  let url = `${DEMO_PLAYER_BASE_URL}#/?p=${projectId}`;

  if (env === "dev") {
    url += `&env=${env}`;
  }

  const flowItems = scenes?.map(getFlowItem).filter(isFlowItem);
  if (flowItems?.length) {
    url += `&flow=${encodeURIComponent(flowItems.join(","))}`;
  }

  if (data) {
    url += `&data=${encodeURIComponent(JSON.stringify(data))}`;
  }

  if (
    playerVersion &&
    playerVersion !== "latest" &&
    playerVersion !== "WARN_NO_PLAYER_VERSION"
  ) {
    url += `&v=${playerVersion.replaceAll(".", "-")}`;
  }

  if (draftVersion) {
    url += `&draftVersion=${draftVersion}`;
  }

  return url;
}
